module.exports = __webpack_public_path__ + "static/media/2.96db6c05.jpeg";